import { FirebasePresenceProvider } from './FirebasePresenceProvider'

export const presenceProvider = new FirebasePresenceProvider()
